// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import $ from 'jquery';
import { slick } from 'slick-carousel';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

// Write your code!
async function main() {
  let yScroll = 0;

  window.addEventListener('load', startUp);

  function startUp() {
    document.querySelector('#read-full').addEventListener('click', function () {
      let shownParagraphs = document.querySelectorAll(
        '#introduction .show:not(:first-child)'
      );

      let showing = shownParagraphs.length > 0;
      console.log(shownParagraphs);
      let text = showing
        ? '▶ Read full introduction'
        : '✕ Collapse introduction';
      document.querySelector('#introduction').dataset.showing = showing
        ? 'f'
        : 't';
      document
        .querySelectorAll('#introduction p:not(:first-child)')
        .forEach((item, i) => {
          if (showing) {
            item.classList.remove('show');
          } else {
            item.classList.add('show');
          }
        });
      event.currentTarget.innerText = text;
    });

    let coverImages = document.querySelectorAll('.parallax');
    console.log(coverImages);
    window.addEventListener('scroll', parallax);

    function parallax() {
      let deltaY = window.scrollY - yScroll;
      yScroll = window.scrollY;
      if (window.scrollY < window.innerHeight) {
        coverImages.forEach((item, i) => {
          let mappedY = deltaY;
          let currentShift = parseInt(
            getComputedStyle(item).getPropertyValue('--shift').replace('px', '')
          );
          let newShift = 0;
          switch (item.dataset.size) {
            case 'small':
              mappedY = 0 * mappedY;
              newShift =
                currentShift + mappedY > 0 ? currentShift + mappedY : 0;
              break;
            case 'medium':
              mappedY = 0 * mappedY;
              newShift =
                currentShift + mappedY > 0 ? currentShift + mappedY : 0;
              break;
            case 'large':
              mappedY = 0 * mappedY;
              newShift =
                currentShift + mappedY > 0 ? currentShift + mappedY : 0;
              break;
          }
          item.style.setProperty('--shift', newShift + 'px');
        });
      }
    }
    let cursor = document.querySelector('#cursor');
    function cursorControl() {
      // console.log(event);
      cursor.style.top = event.clientY + 'px';
      cursor.style.left = event.clientX + 'px';
    }

    startSwiper();
  }

  function startSwiper() {
    $('.carousel').slick({
      dots: false,
      infinite: true,
      arrows: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
    });
  }
}

main();
